<template>
  <div>
   
    <div class="right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label for>道路:</label>
            <search-parking></search-parking>
          </div>
          <div class="form-group">
            <label for>岗位:</label>
            <search-area></search-area>
          </div>
          <div class="form-group">
            <label>开始日期</label>
            <el-date-picker
              v-model="search.startDate"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
          <div class="form-group">
            <label>结束日期</label>
            <el-date-picker
              v-model="search.endDate"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
          <div class="form-group">
            <label>泊位号</label>
            <input
              v-model="search.spaceNum"
              class="form-control"
              type="text"
              placeholder
            />
          </div>
          <div class="form-group">
            <label>设备号</label>
            <input
              v-model="search.deviceSn"
              class="form-control"
              type="text"
              placeholder
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :loading="loading"
                 size="small"
              >
                查询
              </button>
            </span>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
              >
                导出
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          v-loading="loading"
        >
          <el-table-column
            show-overflow-tooltip
            label="日期"
            prop="date"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="停车道路"
            prop="parkingName"
          >
          </el-table-column>
          <el-table-column show-overflow-tooltip label="泊位号" prop="spaceNum">
          </el-table-column>
          <el-table-column show-overflow-tooltip label="设备号" prop="deviceSn">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="下单数"
            prop="orderNumber"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="设备检测进出车次数"
            prop="deviceNumber"
          >
          </el-table-column>
          <el-table-column show-overflow-tooltip label="比率" prop="rate">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { fetchSpaceOrderAnalysisList } from "@/api/url";
import SearchParking from "../../commons/searchParking";
import SearchArea from "../../commons/searchArea";
import Page from "../../commons/page";
export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageSize: 10,
        pageNumber: 1,
        startDate: "",
        endDate: "",
        spaceNum: "",
        deviceSn: "",
      },
      tableListData: [],
      pageObj: {},
      loading: false
    };
  },

  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage) {
      let parkingId, areaId;
      if (this.parking) {
        parkingId = this.parking.parkingId;
      }
      if (this.area) {
        areaId = this.area.areaId;
      }
      this.loading = true;
      this.$get(fetchSpaceOrderAnalysisList(), {
        parkingId,
        areaId,
        limit: this.search.pageSize,
        page: curPage,
        spaceNum: this.search.spaceNum,
        deviceSn: this.search.deviceSn,
        startDate: this.search.startDate,
        endDate: this.search.endDate,
      }).then((res) => {
        const {
          status,
          data: { rows, total, offset },
        } = res;
        var pageObj = {
          curIndex: offset,
          rowsCount: total,
        };
        this.pageObj={...pageObj}
        // this.getPage(pageObj);
        this.tableListData = rows.map((item) => {
          item.parkingName = JSON.parse(item.parkingId).parkingName;
          item.parkingId = JSON.parse(item.parkingId).parkingId;
          item.spaceNum = JSON.parse(item.spaceId).spaceNum;
          item.spaceId = JSON.parse(item.spaceId).spaceId;
          item.rate = (item.rate * 100).toFixed(2) + "%";
          return item;
        });
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  searchList() {
     
        const { startDate, endDate } = this.search;
        var flTime = this.timeCompare(startDate, endDate);
        if (startDate && endDate && flTime) {
          return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
        }
        this.search.pageNumber = "1";
        this.tableList(this.search.pageNumber);
   
    },
    timeCompare: function (bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    downloadData() {
      const { spaceNum, deviceSn, startDate, endDate } = this.search;
      this.$downloadFileRequest(
        "/api/parking/spaceOrderAnalysis/export",
        {
          parkingId: this.parking?.parkingId ?? null,
          areaId: this.area?.areaId ?? null,
          spaceNum:spaceNum?spaceNum:null,
          deviceSn:deviceSn?deviceSn:null,
          startDate:startDate?startDate:null,
          endDate:endDate?endDate:null,
        },
        "泊位使用分析"
      );
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      area: (state) => state.parking.area,
      parking: (state) => state.parking.oneParking,
    }),
  },
  components: {
    Page,
    SearchParking,
    SearchArea,
  },

  mounted: function () {
    this.tableList(this.search.pageNumber);
  },
};
</script>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
</style>